import styled from 'styled-components'

interface SearchIconWrapperProps {
  color?: string
}

export const SearchIconWrapper = styled.div<SearchIconWrapperProps>(
  ({ color, theme }) => `
  ${
    theme.name === 'lightV2'
      ? `
      margin-top: ${theme.spacing(1)}; 
      margin-right: ${theme.spacing(0.5)};
      color: ${color ? color : 'inherit'}
    `
      : ''
  }
`,
)
